import { makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";
import { useAtomValue } from "jotai";
import { chatSessionAtom } from "@/state";
import type { OfficeSelection } from "@/types/api";
import ChatHistory from "./chat-history";
import ChatInput from "./chat-input";
import Toolbar from "./toolbar";

export default function ChatTab({ selection }: { selection: OfficeSelection | null }) {
  const styles = useStyles();
  const session = useAtomValue(chatSessionAtom);

  return (
    <div className={styles.container} role="tabpanel" aria-labelledby="Chat">
      <Toolbar />
      <ChatHistory />
      {!selection && <p className={styles.hint}>Complete the choices above to start chatting.</p>}
      <ChatInput key={session} context={selection?.context ?? null} organizationId={selection?.organizationId ?? ""} />
    </div>
  );
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    paddingTop: "16px",
  },
  hint: { fontSize: "12px", color: tokens.colorNeutralForeground2, margin: "8px 0 0" },

  title: {
    fontSize: "16px",
    marginBottom: "8px",
    color: tokens.colorPaletteLavenderForeground2,
  },
});
